import { NotFound } from "@components/HttpErrors";
import { OrderDetails } from "@pages/backoffice/Acquisition/Order/OrderDetails";
import { OrderEditor } from "@pages/backoffice/Acquisition/Order/OrderEditor";
import { OrderSearch } from "@pages/backoffice/Acquisition/Order/OrderSearch";
import CheckIn from "@pages/backoffice/Actions/CheckIn/CheckIn";
import { CheckOut } from "@pages/backoffice/Actions/CheckOut/CheckOut";
import { DocumentDetails } from "@pages/backoffice/Document/DocumentDetails";
import { DocumentEditor } from "@pages/backoffice/Document/DocumentEditor";
import { DocumentSearch } from "@pages/backoffice/Document/DocumentSearch";
import { DocumentRequestDetails } from "@pages/backoffice/DocumentRequest/DocumentRequestDetails";
import { DocumentRequestEditor } from "@pages/backoffice/DocumentRequest/DocumentRequestEditor";
import { DocumentRequestSearch } from "@pages/backoffice/DocumentRequest/DocumentRequestSearch";
import { EItemDetails } from "@pages/backoffice/EItem/EItemDetails";
import { EItemEditor } from "@pages/backoffice/EItem/EItemEditor";
import { EItemSearch } from "@pages/backoffice/EItem/EItemSearch";
import Home from "@pages/backoffice/Home/Home";
import { BorrowingRequestDetails } from "@pages/backoffice/ILL/BorrowingRequest/BorrowingRequestDetails";
import { BorrowingRequestEditor } from "@pages/backoffice/ILL/BorrowingRequest/BorrowingRequestEditor/BorrowingRequestEditor";
import { BorrowingRequestSearch } from "@pages/backoffice/ILL/BorrowingRequest/BorrowingRequestSearch/BorrowingRequestSearch";
import { ItemDetails } from "@pages/backoffice/Item/ItemDetails";
import { ItemEditor } from "@pages/backoffice/Item/ItemEditor";
import { ItemSearch } from "@pages/backoffice/Item/ItemSearch";
import { LoanDetails } from "@pages/backoffice/Loan/LoanDetails";
import { LoanSearch } from "@pages/backoffice/Loan/LoanSearch";
import { InternalLocationEditor } from "@pages/backoffice/Location/InternalLocationEditor";
import { LocationDetails } from "@pages/backoffice/Location/LocationDetails";
import { LocationEditor } from "@pages/backoffice/Location/LocationEditor";
import { LocationList } from "@pages/backoffice/Location/LocationList";
import { PatronDetails } from "@pages/backoffice/Patron/PatronDetails";
import { PatronSearch } from "@pages/backoffice/Patron/PatronSearch";
import { ProviderDetails } from "@pages/backoffice/Providers/ProviderDetails";
import { ProviderEditor } from "@pages/backoffice/Providers/ProviderEditor";
import { ProviderSearch } from "@pages/backoffice/Providers/ProviderSearch";
import { SeriesDetails } from "@pages/backoffice/Series/SeriesDetails";
import { SeriesEditor } from "@pages/backoffice/Series/SeriesEditor";
import { SeriesSearch } from "@pages/backoffice/Series/SeriesSearch";
import Stats from "@pages/backoffice/Stats/Stats";
import {
  AcquisitionRoutes,
  BackOfficeRoutes,
  ILLRoutes,
  ProviderRoutes,
} from "@routes/urls";
import React, { Component } from "react";
import Overridable from "react-overridable";
import { Route, Switch } from "react-router-dom";
import { MostLoanedDocumentsList } from "@pages/backoffice/Stats/MostLoanedDocumentsList";
import { OverdueDocumentsList } from "@pages/backoffice/Stats/OverdueDocumentsList";
import { SpecialCollectionsSearch } from "@pages/backoffice/SpecialCollections/SpecialCollectionSearch/SpecialCollectionsSearch";
import { SpecialCollectionEditor } from "@pages/backoffice/SpecialCollections/SpecialCollectionEditor/SpecialCollectionEditor";
import { SpecialCollectionDetails } from "@pages/backoffice/SpecialCollections/SpecialCollectionDetails";
import { FineManagementList } from "@pages/backoffice/Fee/FineManagementList";
import { DocumentLabelsSearch } from "@pages/backoffice/DocumentLabels";
import { DocumentLabelsSelected } from "@pages/backoffice/DocumentLabels/DocumentLabelsSelected";
import { DocumentLabelsFormat } from "@pages/backoffice/DocumentLabels/DocumentLabelsFormat";
import { TopBorrowersList } from "@pages/backoffice/Stats/TopBorrowersList";
import { PickBorrowingList } from "@pages/backoffice/Stats/PickBorrowingList";
import { WeededDocuments } from "@pages/backoffice/Document/DocumentWeeding/WeededDocuments";
import OPACStatisticsDashboard from "@pages/backoffice/Stats/OpacStats/OPACStatisticsDashboard";
import { CatalogActivityLogs } from "@pages/backoffice/AuditLogs/CatalogLogging";
import DocumentUsage from "@pages/backoffice/Stats/DocumentUsage/DocumentUsage";
import { AttendanceSummary } from "@pages/backoffice/Attendance/AttendanceSummary";
import { ProtectedRoute } from "@authentication/components/AdminAccess/AdminAccess";
import { Configurables } from "@pages/backoffice/Configurables/Configurables";
import { CollegeProgramManagement } from "@pages/backoffice/ManageCollegeProgram/College";

export default class BackOfficeRoutesSwitch extends Component {
  render() {
    return (
      <Switch>
        <Route exact path={BackOfficeRoutes.home} component={Home} />
        <Route
          exact
          path={BackOfficeRoutes.auditLogs}
          component={CatalogActivityLogs}
        />

        {/* LIBRARIAN ACCESS ROUTES */}
        {/* documents */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentCreate}
          component={DocumentEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentsList}
          component={DocumentSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentEdit}
          component={DocumentEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentDetails}
          component={DocumentDetails}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.specialColList}
          component={SpecialCollectionsSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.specialColCreate}
          component={SpecialCollectionEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.specialColDetails}
          component={SpecialCollectionDetails}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.specialColEdit}
          component={SpecialCollectionEditor}
        />
        {/* eitems */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.eitemsList}
          component={EItemSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.eitemCreate}
          component={EItemEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.eitemEdit}
          component={EItemEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.eitemDetails}
          component={EItemDetails}
        />
        {/* items */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.itemsList}
          component={ItemSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.itemCreate}
          component={ItemEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.itemEdit}
          component={ItemEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.itemDetails}
          component={ItemDetails}
        />
        {/* loans */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.loansList}
          component={LoanSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.loanDetails}
          component={LoanDetails}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.fineManagement}
          component={FineManagementList}
        />
        {/* internal locations */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.ilocationsCreate}
          component={InternalLocationEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.ilocationsEdit}
          component={InternalLocationEditor}
        />
        {/* locations */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.locationsList}
          component={LocationList}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.locationsCreate}
          component={LocationEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.locationsEdit}
          component={LocationEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.locationsDetails}
          component={LocationDetails}
        />
        {/* providers */}
        <ProtectedRoute
          exact
          path={ProviderRoutes.providersList}
          component={ProviderSearch}
        />
        <ProtectedRoute
          exact
          path={ProviderRoutes.providerCreate}
          component={ProviderEditor}
        />
        <ProtectedRoute
          exact
          path={ProviderRoutes.providerEdit}
          component={ProviderEditor}
        />
        <ProtectedRoute
          exact
          path={ProviderRoutes.providerDetails}
          component={ProviderDetails}
        />
        {/* patrons */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.patronsList}
          component={PatronSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.patronDetails}
          component={PatronDetails}
        />
        {/* series */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.seriesList}
          component={SeriesSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.seriesCreate}
          component={SeriesEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.seriesEdit}
          component={SeriesEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.seriesDetails}
          component={SeriesDetails}
        />
        {/* document requests */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentRequestCreate}
          component={DocumentRequestEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentRequestDetails}
          component={DocumentRequestDetails}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentRequestEdit}
          component={DocumentRequestEditor}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentRequestsList}
          component={DocumentRequestSearch}
        />
        {/* orders */}
        <ProtectedRoute
          exact
          path={AcquisitionRoutes.ordersList}
          component={OrderSearch}
        />
        <ProtectedRoute
          exact
          path={AcquisitionRoutes.orderCreate}
          component={OrderEditor}
        />
        <ProtectedRoute
          exact
          path={AcquisitionRoutes.orderEdit}
          component={OrderEditor}
        />
        <ProtectedRoute
          exact
          path={AcquisitionRoutes.orderDetails}
          component={OrderDetails}
        />
        {/* ILL */}
        <ProtectedRoute
          exact
          path={ILLRoutes.borrowingRequestList}
          component={BorrowingRequestSearch}
        />
        <ProtectedRoute
          exact
          path={ILLRoutes.borrowingRequestCreate}
          component={BorrowingRequestEditor}
        />
        <ProtectedRoute
          exact
          path={ILLRoutes.borrowingRequestEdit}
          component={BorrowingRequestEditor}
        />
        <ProtectedRoute
          exact
          path={ILLRoutes.borrowingRequestDetails}
          component={BorrowingRequestDetails}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.checkIn}
          component={CheckIn}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.checkOut}
          component={CheckOut}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentLabels}
          component={DocumentLabelsSearch}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentLabelsSelected}
          component={DocumentLabelsSelected}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.documentLabelsFormat}
          component={DocumentLabelsFormat}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.weededDocuments}
          component={WeededDocuments}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.attendaceSummary}
          component={AttendanceSummary}
        />
        <Route
          exact
          path={BackOfficeRoutes.configurables}
          component={Configurables}
        />
        <Route
          exact
          path={BackOfficeRoutes.college}
          component={CollegeProgramManagement}
        />
        {/* stats */}
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.stats.home}
          component={Stats}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.stats.mostLoaned}
          component={() => (
            <div className="stats-container">
              <h1>MOST LOANED DOCUMENTS</h1>
              <MostLoanedDocumentsList />
            </div>
          )}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.stats.overdue}
          render={() => (
            <div className="stats-container overdue-documents-container">
              <h1>OVERDUE DOCUMENTS</h1>
              <OverdueDocumentsList />
            </div>
          )}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.stats.topBorrowers}
          component={() => (
            <div className="stats-container">
              <h1>TOP BORROWERS</h1>
              <TopBorrowersList />
            </div>
          )}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.stats.documentUsage}
          component={() => (
            <div className="stats-container">
              <h1>DOCUMENT USAGE</h1>
              <DocumentUsage />
            </div>
          )}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.stats.pickBorrowing}
          component={() => (
            <div className="stats-container">
              <PickBorrowingList />
            </div>
          )}
        />
        <ProtectedRoute
          exact
          path={BackOfficeRoutes.stats.opacUsage}
          component={() => (
            <div className="stats-container">
              <OPACStatisticsDashboard />
            </div>
          )}
        />
        <Overridable id="BackOfficeRoutesSwitch.CustomRoute">
          <Route>
            <NotFound />
          </Route>
        </Overridable>
      </Switch>
    );
  }
}
